import React, {  useState } from 'react';
import styled from 'styled-components';
import Filter from '../components/Icon/Filter';
import Dollar from '../components/Icon/Dollar';
import { useData } from '../context/DataProvider';
import ProductModal from '../components/ProductModal';
import RedirectModal from '../components/RedirectModal';

const MostSearched = () => {
  const { data , sessionExpired} = useData();
  const [activeSortKey, setActiveSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
 const [truncatedStates, setTruncatedStates] = useState({});
 const [isModalOpen, setIsModalOpen] = useState(false);
 const [selectedProduct, setSelectedProduct] = useState(null);
   const handleRowClick = (product) => {
     setSelectedProduct(product);
     setIsModalOpen(true);
   };

  const toggleTruncate = (productId) => {
    setTruncatedStates(prevState => ({
      ...prevState,
      [productId]: !prevState[productId]
    }));
  };
  const handleSortChange = (sortKey) => {
    if (activeSortKey === sortKey) {
      setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setActiveSortKey(sortKey);
      setSortDirection('asc');
    }
  };

  const sortedProducts = [...data.popularProducts].sort((a, b) => {
    if (!activeSortKey) return 0;
    const order = sortDirection === 'asc' ? 1 : -1;
  
    switch (activeSortKey) {
      // case 'dateAdded':
      //   return order * (new Date(a.date_created) - new Date(b.date_created));
      case 'price':
        return order * (parseInt(a.priceRange) - parseInt(b.priceRange));
      case 'name':
      case 'brand':
        return order * a[activeSortKey].localeCompare(b[activeSortKey]);
      case 'category':
        return order * (a.categories[0]?.name || '').localeCompare(b.categories[0]?.name || '');
        case "ingredients":
          return order * (a.ingredients[0] || '').localeCompare(b.ingredients[0] || ''); 
         case "attribute":
          return order * (a.attributes[0]?.name || '').localeCompare(b.attributes[0]?.name || '');  
        default:
        return 0;
    }
  });

  const getSortIcon = (sortKey) => {
    return (
      <FilterButton 
        onClick={() => handleSortChange(sortKey)}
        style={{
          transform: activeSortKey === sortKey && sortDirection === 'desc' ? 'rotate(180deg)' : 'none'
        }}
      >
        <Filter style={{
          color: activeSortKey === sortKey ? '#3B82F6' : 'inherit'
        }} />
      </FilterButton>
    );
  };

  return (
    <Container>
      <RedirectModal isOpen={sessionExpired}/>
      <InnerContainer>
      {sortedProducts.length > 0  && <ResultTxt>Showing <RsltSpan>{sortedProducts.length} results</RsltSpan></ResultTxt>}
      <ProductModal
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
      />
      <TableWrapper>
        <Table>
          <THead>
            <TR>
              <TH>
                <THContent>
                  <Span>Most Searched Products</Span>
                  {getSortIcon('name')}
                </THContent>
              </TH>
              {/* <TH>
                <THContent>
                  <Span>Launch date</Span>
                  {getSortIcon('dateAdded')}
                </THContent>
              </TH> */}
              <TH>
                <THContent>
                  <Span>Brand</Span>
                  {getSortIcon('brand')}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Price</Span>
                  {getSortIcon('price')}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Category</Span>
                  {getSortIcon('category')}
                </THContent>
              </TH>
               <TH>
                <THContent>
                  <Span>Attribute</Span>
                  {getSortIcon("attribute")}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Ingredient list</Span>
                  {getSortIcon("ingredients")}
                </THContent>
              </TH>
            </TR>
          </THead>
          <TBody>
            {sortedProducts.map((product) => (
              <TR key={product.id}>
                <TD  onClick={() => handleRowClick(product)}>
                  <ProductCell>
                  <ProductImage>
                      <Img 
                        src={product.image.fullsize} 
                        height={58} 
                        width={58} 
                        alt={product.name} 
                      />
                       {product.discontinued === "1" &&
            
            
            <Overlay>
              <OverlayTxt>
              DISCONTINUED
              </OverlayTxt>
              </Overlay>}
                    </ProductImage>
                    <ProductInfo>
                      {/* <ProductName>{product.name}</ProductName> */}
                      <ProductDescription>{product.name}</ProductDescription>
                    </ProductInfo>
                  </ProductCell>
                </TD>
                {/* <TD style={{color:'#2F323799'}}>{product.date_created.split(' ')[0]}</TD> */}
                <TD>{product.brand}</TD>
                <TD>
                  <PriceWrapper>
                    {[...Array(Number(product.priceRange || 0))].map((_, index) => (
                      <Dollar key={index} />
                    ))}
                  </PriceWrapper>
                </TD>
                <TD>{product.categories.map(cat => cat.name).join(", ") || 'Uncategorized'}</TD>
                 <TD>
  {product.attributes
    .filter(cat => cat.type !== 'Internal')
    .map(cat => cat.name)
    .join(", ") || '-'}
</TD>
                <TD  onClick={()=>toggleTruncate(product.id)} style={{ color: "#2F323799", whiteSpace: 'normal', wordBreak: 'break-word' }}>
  {truncatedStates[product.id] 
    ? (Array.isArray(product.ingredients) ? product.ingredients.join(', ') : product.ingredients) 
    : (Array.isArray(product.ingredients) ? product.ingredients.join(', ').slice(0, 37) + '...' : product.ingredients.slice(0, 37) + '...')}
</TD>
              </TR>
              
            ))}
          </TBody>
        </Table>
        </TableWrapper>
      </InnerContainer>
    </Container>
  );
};

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: #FFFFFF;
  border-radius: 24px;
  box-shadow: 0px 0px 24px 0px #2F323705;
  // NO overflow here
`;


const TableWrapper = styled.div`
  max-height: 70vh;
  
  border-radius: 18px;
  position: relative;
   overflow: auto;
  
  
  &::-webkit-scrollbar {
    width: 4px;  /* Increased width for better visibility */
  }
  
  &::-webkit-scrollbar-track {
    background: #grey;  /* Visible track color */
    border-radius: 1px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: black;
    border-radius: 1px;
  }
  
  
  scrollbar-width: thin;
  scrollbar-color: black #grey;  /* Thumb and track color */
  

`;

const Table = styled.table`
  // min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #F9F9F9;
  border-radius: 18px;
`;

const THead = styled.thead`
  font-family: PPMori;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #F9F9F9;
`;

const TH = styled.th`
  padding: 30px;
  text-align: left;
  font-weight: 600;
  font-family: PPMori;
  background: #F9F9F9;
  
  position: sticky;
  top: 0;
  z-index: 10;

  &:first-child {
    left: 0;
    z-index: 20; /* higher than other headers */
  }
`;

const TBody = styled.tbody``
const Span = styled.span``
const Img = styled.img`object-fit: contain;`

const Container = styled.div`

padding: 30px;
gap: 30px;
border: 0px 1px 0px 0px;
opacity: 0px;

`


const TR = styled.tr`
cursor: pointer;
  border-top: 1px solid #0000001A;
  &:first-child {
    border-top: none;
  }
`;

const THContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TD = styled.td`
  padding: 20px 30px;
position: sticky;
background: #F9F9F9;
font-size: 15px;
font-weight: 500;
line-height: 19.2px;
letter-spacing: -0.01em;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;
&:first-child {
    position: sticky;
    left: 0;
    z-index: 5;
    background: #F9F9F9;
  }
`;

const FilterButton = styled.button`
  background: #F9F9F9;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
`;

const ProductCell = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;


const RsltSpan= styled.span`

font-weight: 600;
font-size: 14px;
line-height: 120%;
letter-spacing: -1%;
color: #202327;
`
const ResultTxt= styled.p`

font-weight: 600;
font-size: 14px;
line-height: 120%;
letter-spacing: -1%;
color: #20232799;
margin: 0px 30px;

`
const ProductImage = styled.div`
  position: relative;
  padding: 6px;
  background: white;
  border-radius: 12px;
  // overflow: hidden;
`;

const OverlayTxt = styled.p`
font-family: PPMori;
font-weight: 800;
font-size: 10px;
line-height: 10px;
letter-spacing: -1%;
margin:0;
color: rgba(32, 35, 39, 1);


`
const Overlay = styled.div`
  position: absolute;
  
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  background:rgba(255, 255, 255, 1);
  color: black;
  font-weight: bold;
  font-size: 12px;
  padding: 2px 6px;
  height: 17px;
  // width:103px;
  border-radius: 4px;
  z-index: 2;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;



const ProductDescription = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #202327;
  letter-spacing: -0.01em;
`;

const PriceWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export default MostSearched;